import * as tus from 'tus-js-client'

const getCSRFToken = (): string => {
  const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('csrftoken='))
  return cookie ? cookie.split('=')[1] : ''
}

// O dono do upload é o usuário autenticado pelo cookie da sessão; o backend
// ignora qualquer user_id enviado no metadata (PSV-407).
export const tusUploadFile = (
  file: File,
  onProgress: (percentage: number) => void
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const endpoint = `${process.env.REACT_APP_API_URL}/upload/`.replace(
      /([^:])\/\//g,
      '$1/'
    )

    const upload = new tus.Upload(file, {
      endpoint,
      chunkSize: 10 * 1024 * 1024,
      retryDelays: [0, 3000, 5000, 10000],
      metadata: {
        filename: file.name,
        app: 'processing',
      },
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
      onBeforeRequest(req) {
        const xhr = req.getUnderlyingObject() as XMLHttpRequest
        xhr.withCredentials = true
      },
      onProgress(bytesUploaded, bytesTotal) {
        const percentage = Math.round((bytesUploaded / bytesTotal) * 100)
        onProgress(percentage)
      },
      onError(error) {
        reject(error)
      },
      onSuccess() {
        const url = upload.url ?? ''
        const uploadId = url.split('/').filter(Boolean).pop() ?? ''
        resolve(uploadId)
      },
    })

    upload.start()
  })
}
